<template>
  <div class="page-password">
    <div class="page-header">
      <h2>{{ type === 'change' ? '修改密码' : '设置密码' }}</h2>
    </div>
    <div class="page-body">
      <change v-if="type === 'change'"></change>
      <new v-if="type === 'new'"></new>
    </div>
    <div class="page-footer" v-if="type === 'change'">
      <div class="mod-tip" v-if="userType === 0">
        <a-icon type="exclamation-circle" theme="filled" />若忘记原始密码，您可以使用 <router-link to="/authenticate?type=password">线上实名认证方式</router-link> 修改密码，或致电{{ app.name }}客服热线{{ app.hotline }}协助您找回密码。
      </div>
      <div class="mod-tip" v-else>
        <a-icon type="exclamation-circle" theme="filled" />若忘记原始密码，您可以致电{{ app.name }}客服热线{{ app.hotline }}协助您找回密码。
      </div>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string'
import Change from './components/Change'
import New from './components/New'
import fromApp from '@/utils/from'
import './index'

export default {
  data () {
    return {
      type: 'change',
      userType: 0,
      app: null
    }
  },
  created () {
    const params = queryString.parse(location.search)
    this.type = params.type || 'change'
    const userInfo = this.$ls.get('USER_CENTER_INFO')

    if (userInfo) {
      this.userType = userInfo.userType
    }

    this.app = fromApp()
  },
  components: {
    Change,
    New
  }
}
</script>
